enum OrderByType {
    Newest = 'newest',
    Oldest = 'oldest',
}

export default OrderByType;
